// src/services/goalRuleService.js
//
// Reads and saves the goal rule sets (rules: goalRules.js). One document per
// goal per start month: goalRuleSets/{metric}__{YYYY-MM}. Saving for a month
// makes those the rules from that month on; earlier months keep theirs.

import { collection, doc, getDocs, query, serverTimestamp, setDoc, where } from "firebase/firestore";
import { db } from "../firebase";
import { getGoalRuleSetsPath } from "./firestorePaths";
import { normalizeRules, ruleSetId } from "./goalRules";

/** Every saved rule set for a goal: [{ effectiveFrom, rules, updatedBy }]. */
export const loadRuleSets = async (metric) => {
  const snap = await getDocs(query(collection(db, getGoalRuleSetsPath()), where("metric", "==", metric)));
  return snap.docs.map((d) => {
    const data = d.data() || {};
    return { effectiveFrom: data.effectiveFrom, rules: normalizeRules(data.rules), updatedBy: data.updatedBy || "" };
  });
};

/** Save the rules for a goal from `monthId` on (an empty list means "no rules from then on"). */
export const saveRuleSet = async ({ metric, monthId, rules, by }) => {
  await setDoc(doc(db, getGoalRuleSetsPath(), ruleSetId(metric, monthId)), {
    metric,
    effectiveFrom: monthId,
    rules: normalizeRules(rules),
    updatedBy: String(by || "").toLowerCase(),
    updatedAt: serverTimestamp(),
  });
};
